// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/task.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.app.v1.TaskAuditSuccessResult
 */
export interface TaskAuditSuccessResult {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 100
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.TaskAuditErrorResult
 */
export interface TaskAuditErrorResult {
    /**
     * TODO(pquerna): expand
     *
     * @generated from protobuf field: int64 error_count = 1
     */
    errorCount: number;
    /**
     * @generated from protobuf field: string error_reason = 2
     */
    errorReason: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.TaskAuditCancelledResult
 */
export interface TaskAuditCancelledResult {
}
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditSuccessResult$Type extends MessageType<TaskAuditSuccessResult> {
    constructor() {
        super("c1.api.app.v1.TaskAuditSuccessResult", [
            { no: 100, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TaskAuditSuccessResult>): TaskAuditSuccessResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<TaskAuditSuccessResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditSuccessResult): TaskAuditSuccessResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated google.protobuf.Any annotations */ 100:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditSuccessResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated google.protobuf.Any annotations = 100; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TaskAuditSuccessResult
 */
export const TaskAuditSuccessResult = new TaskAuditSuccessResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditErrorResult$Type extends MessageType<TaskAuditErrorResult> {
    constructor() {
        super("c1.api.app.v1.TaskAuditErrorResult", [
            { no: 1, name: "error_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "error_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditErrorResult>): TaskAuditErrorResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.errorCount = 0;
        message.errorReason = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditErrorResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditErrorResult): TaskAuditErrorResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 error_count */ 1:
                    message.errorCount = reader.int64().toNumber();
                    break;
                case /* string error_reason */ 2:
                    message.errorReason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditErrorResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 error_count = 1; */
        if (message.errorCount !== 0)
            writer.tag(1, WireType.Varint).int64(message.errorCount);
        /* string error_reason = 2; */
        if (message.errorReason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TaskAuditErrorResult
 */
export const TaskAuditErrorResult = new TaskAuditErrorResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditCancelledResult$Type extends MessageType<TaskAuditCancelledResult> {
    constructor() {
        super("c1.api.app.v1.TaskAuditCancelledResult", []);
    }
    create(value?: PartialMessage<TaskAuditCancelledResult>): TaskAuditCancelledResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditCancelledResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditCancelledResult): TaskAuditCancelledResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditCancelledResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TaskAuditCancelledResult
 */
export const TaskAuditCancelledResult = new TaskAuditCancelledResult$Type();
